import { createStructureStatementHandler } from '../../createStructureStatementHandler';
export const removeCommentStmtInstruction = `
#### Remove Comment
Remove a comment from a view or scope. This is useful for removing notes or descriptions from your views and scopes.

- Syntax: \`remove comment <order> in <view_name>.<scope_name>;\`
- Example: \`remove comment 1 in ProductList.ProductScope;\`
`;
export const stmtRemoveStructureComment = ({ order, viewName, scopeName }) => {
    if (scopeName) {
        return `remove comment ${order} in ${viewName}.${scopeName};`;
    }
    return `remove comment ${order} in ${viewName};`;
};
export const removeCommentHandler = createStructureStatementHandler({
    type: 'remove comment',
    parse: line => {
        const match = /^(remove|delete) comment (?<order>[\d]+) in (?<viewName>\w+)(.(?<scopeName>\w+))?/.exec(line);
        return match?.groups
            ? {
                type: 'remove comment',
                order: Number.parseInt(match.groups.order),
                viewName: match.groups.viewName,
                scopeName: match.groups.scopeName,
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.removeComment({
                order: stmt.order,
                viewName: stmt.viewName,
                scopeName: stmt.scopeName,
            });
        });
    },
});
//# sourceMappingURL=RemoveCommentStmt.js.map